<h3>{{ 'title_visualizarusuario_edit' | translate:_transParam }}</h3>
<mat-card class="card">
    <div class="d-flex flex-wrap gap-2">
        <signaturit-input #input labelName="{{ ('visualizar_label_name' | translate ) }}"
            [inputValue]="form.get('name').value" (outputValue)="updateFormValue($event, 'name')" inputType="text"
            inputWidth="312" [isRequired]="true" [messageError]="requiredMessageError"></signaturit-input>

        <signaturit-input #input labelName="{{ ('visualizar_label_username' | translate ) }}"
            [inputValue]="form.get('nif').value" (outputValue)="updateFormValue($event, 'nif')" inputType="text"
            inputWidth="312" [isRequired]="true" [messageError]="requiredMessageError"></signaturit-input>

        <signaturit-input *ngIf="!hidePassword" #input labelName="{{ ('visualizar_label_password' | translate ) }}"
            [inputValue]="form.get('pass').value" (outputValue)="updateFormValue($event, 'pass')" inputType="password"
            inputWidth="312" [isRequired]="true" [messageError]="requiredMessageError"></signaturit-input>

        <signaturit-input *ngIf="!hidePassword" #input
            labelName="{{ ('visualizar_label_passwordRepeat' | translate ) }}"
            [inputValue]="form.get('passRepeat').value" (outputValue)="updateFormValue($event, 'passRepeat')"
            inputType="password" inputWidth="312" [isRequired]="true" [messageError]="requiredMessageError"></signaturit-input>

        <signaturit-input #input labelName="{{ ('visualizar_label_email' | translate ) }}"
            [inputValue]="form.get('email').value" (outputValue)="updateFormValue($event, 'email')" inputType="text"
            inputWidth="312" [isRequired]="true" [messageError]="requiredMessageError"></signaturit-input>

        <signaturit-input #input labelName="{{ ('visualizar_label_phone' | translate ) }}" [minLength]="9"
            [maxLength]="10" [inputValue]="form.get('phone').value" (outputValue)="updateFormValue($event, 'phone')"
            inputType="text" inputWidth="312"></signaturit-input>

        <signaturit-select #select width="312" (selectOption)="updateFormValue($event.value?.value, 'idTimezone')"
            labelName="{{'visualizar_label_idTimezone' | translate }}" [required]="true" [messageError]="requiredMessageError" [data]="timeZones"
            dataValue="label" dataKey="value" [selectedValue]="form.get('idTimezone').value"></signaturit-select>
    </div>

    <div class="form__actions">
        <signaturit-button [text]="'footer_btn_form_clean' | translate" type="tertiary" size="md"
            (click)="clean()"></signaturit-button>
        <div class="actions__right">
            <signaturit-button [text]="'footer_btn_form_return' | translate" type="tertiary" size="md"
                (click)="return()"></signaturit-button>
            <signaturit-button [text]="'footer_btn_form_save' | translate" type="secondary" size="md"
                [disabled]="!form.valid" (click)="submitForm()"></signaturit-button>
        </div>
    </div>
</mat-card>
